import api from "../config/api";

export const getExpenseCategories = async (data) => {
  const res = await api.get("expenseCategory", data);
  return res.data;
};

export const getExpenseCategoryByid = async (_id) => {
  const res = await api.get(`expenseCategory/${_id}`);
  return res.data;
};
